import { render, staticRenderFns } from "./SpeechParamsSection.vue?vue&type=template&id=10153510&scoped=true"
import script from "./SpeechParamsSection.vue?vue&type=script&lang=js"
export * from "./SpeechParamsSection.vue?vue&type=script&lang=js"
import style0 from "./SpeechParamsSection.vue?vue&type=style&index=0&id=10153510&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10153510",
  null
  
)

export default component.exports